import React from 'react'
import AlumniDash from '../../Components/AlumniComponent/AlumniDash/AlumniDash'
import NotesShares from '../../Components/TeacherComponents/NotesShare/NotesShares'

function SharedNotesPage() {
  return (
    <AlumniDash>
        <NotesShares/>
    </AlumniDash>
  )
}

export default SharedNotesPage